import {
  useTranslate,
  IResourceComponentsProps,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  DateField,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
} from "@pankod/refine-antd";
import { IAppVersion } from "interfaces";

export const AppVersionList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { tableProps, sorter } = useTable<IAppVersion>({
    initialSorter: [
      {
        field: "app_version_id",
        order: "desc",
      },
    ],
  });

  return (
    <List>
      <Table {...tableProps} rowKey="app_version_id">
        <Table.Column
            dataIndex="app_version_id"
            key="app_version_id"
            title={t("app-version.fields.app_version_id")}
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("app_version_id", sorter)}
            sorter
        />
        <Table.Column
            dataIndex="version"
            key="version"
            title={t("app-version.fields.version")}
            render={(value) => <TextField value={value} />}
        />
        <Table.Column
            dataIndex="created_at"
            key="created_at"
            title={t("parameter.fields.created_at")}
            render={(value) => <DateField value={value} format="LLL" />}
        />
        <Table.Column<IAppVersion>
            title={t("table.actions")}
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                <EditButton hideText size="small" recordItemId={record.app_version_id} />
                <ShowButton hideText size="small" recordItemId={record.app_version_id} />
                <DeleteButton hideText size="small" recordItemId={record.app_version_id} />
              </Space>
            )}
        />
      </Table>
    </List>
  );
};
